<ng-container *ngIf="trocouPara as nova; else estadoAtual">
  <p class="ext-ok"><i class="fe-check-circle" aria-hidden="true"></i><span>Este número agora usa a <b>{{nova.rotulo}}</b>.</span></p>
  <p>Falta instalar: no computador do WhatsApp Web deste número, baixe a {{nova.rotulo}}, desative a outra versão e abra o WhatsApp Web. Até lá as mensagens esperam na fila.</p>
  <a class="ext-baixar" [href]="nova.url" target="_blank" rel="noopener noreferrer"><i class="fe-download" aria-hidden="true"></i>Baixar {{nova.rotulo}}<i class="fe-arrow-up-right" aria-hidden="true"></i></a>
</ng-container>
<ng-template #estadoAtual>
  <p class="ext-atual">Este número usa a <b>{{extensao.rotulo}}</b>
    <small class="ext-status ok" *ngIf="extensao.versao === 4 && conectada === true">Conectada agora</small>
    <small class="ext-status alerta" *ngIf="extensao.versao === 4 && conectada === false">Não conectada</small>
  </p>
  <a class="ext-link" [href]="extensao.url" target="_blank" rel="noopener noreferrer"><i class="fe-download" aria-hidden="true"></i>Baixar {{extensao.rotulo}}<i class="fe-arrow-up-right" aria-hidden="true"></i></a>
  <ng-container *ngIf="podeTrocar">
    <button type="button" class="ext-trocar" *ngIf="!confirmando" (click)="confirmando = true">
      <i class="fe-repeat" aria-hidden="true"></i>Trocar para a {{outra.rotulo}}
    </button>
    <div class="ext-confirma" *ngIf="confirmando">
      <strong>Trocar para a {{outra.rotulo}}</strong>
      <ol>
        <li>Baixe a <b>{{outra.rotulo}}</b> no Chrome do WhatsApp Web deste número.
          <a class="ext-baixar" [href]="outra.url" target="_blank" rel="noopener noreferrer"><i class="fe-download" aria-hidden="true"></i>Baixar {{outra.rotulo}}<i class="fe-arrow-up-right" aria-hidden="true"></i></a></li>
        <li>Desative a {{extensao.rotulo}} no Chrome.</li>
        <li>Abra o WhatsApp Web e conecte.</li>
      </ol>
      <p class="ext-aviso">Até a {{outra.rotulo}} conectar, este número não envia: as mensagens ficam guardadas na fila.<ng-container *ngIf="extensao.versao === 4"> Na V3 o limite por dia deixa de valer.</ng-container></p>
      <p class="ext-erro" role="alert" *ngIf="erro">{{erro}}</p>
      <div class="ext-acoes">
        <button type="button" (click)="confirmando = false" [disabled]="trocando">Cancelar</button>
        <button type="button" class="primario" (click)="confirmar()" [disabled]="trocando">{{trocando ? 'Trocando...' : 'Trocar agora'}}</button>
      </div>
    </div>
  </ng-container>
</ng-template>
